import { render, staticRenderFns } from "./popup-click-dispatch.vue?vue&type=template&id=79cdda68&scoped=true"
import script from "./popup-click-dispatch.vue?vue&type=script&lang=js"
export * from "./popup-click-dispatch.vue?vue&type=script&lang=js"
import style0 from "./popup-click-dispatch.vue?vue&type=style&index=0&id=79cdda68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cdda68",
  null
  
)

export default component.exports